import { colors } from '@styles/vars/colors.style'
import styled from 'styled-components'
import { mq } from '@styles/vars/media-queries.style'
import { clamp } from '@styles/utils/conversion.style'

export const ServiceFilterMain = styled.div`
    position: relative;
    ${mq.tabletPMax} {
        flex: 1;
    }
`

export const ServiceFilterButton = styled.div`
    display: flex;
    align-items: center;
    padding: 8px 10px 8px 25px;
    border: 1px solid ${colors.charcoal};
    border-radius: 7rem;
    cursor: pointer;
    background: ${colors.white};
    max-width: 233px;
    ${mq.tabletPMax} {
        margin-left: auto;
        padding: 5px 5px 5px 14px;
    }
    svg {
        margin-right: auto;
        width: 24px;
        height: 26px;
    }
`

export const ServiceFilterTitle = styled.div`
    ${clamp('font-size', 15, 22)};
    flex: 1;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    margin-right: 10px;
    line-height: 22px;
`

export const ServiceFilterDropdown = styled.div`
    position: absolute;
    max-height: 412px;
    overflow-y: auto;
    scrollbar-width: thin;
    top: calc(100% + 12px);
    border: 1px solid #E8E8E8;
    box-shadow: 1px 0px 20px rgba(218, 218,218,0.5);
    background: ${colors.white};
    border-radius: 4px;
    z-index: 5;
    transition: all 0.25s ease;
    opacity: ${props => props.active ? '1' : '0'};
    transform: ${props => props.active ? 'translateY(0)' : 'translateY(-10px)'};
    visibility: ${props => props.active ? 'visible' : 'hidden'};
    right: 0;
    width: calc(100vw - 30px);
    max-width: 410px;
    ${mq.desk} {
        width: 412px;
        left: -20px;
    }
`

export const ServiceFilterItem = styled.div`
    padding: 20px;
    cursor: pointer;
    display: flex;
    align-items: center;
    ${clamp('font-size', 16, 22)};
    &:hover {
        background: #E8E8E8;
    }
    &:not(:last-child) {
        border-bottom: 1px solid #E8E8E8;
    }
`

export const Check = styled.div`
    height: 20px;
    width: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 2px solid ${colors.charcoal};
    border-radius: 2px;
    margin-right: 10px;
    background: ${props => props.active ? colors.charcoal : colors.white};
    svg {
        color: ${colors.white};
        opacity: ${props => props.active ? '1' : '0'};
        height: 18px;
        width: 18px;
        stroke-width: 3px;
        position: absolute;
    }
`
